import { Link } from 'react-router-dom';
import { BRAND_LOGO_PNG } from '../brandAssets';

type BrandLogoLinkProps = {
  className?: string;
  /** Tailwind classes for the image (e.g. smaller in modals) */
  imgClassName?: string;
};

/**
 * `logo.png` from `public/assets/` — used on auth surfaces (login, sign-up, reset, drawer).
 */
export function BrandLogoLink({
  className = 'shrink-0',
  imgClassName = 'h-10 w-auto max-w-[min(80vw,260px)] object-contain',
}: BrandLogoLinkProps) {
  return (
    <Link to="/" className={className} aria-label="Hyper App Store home">
      <img
        src={BRAND_LOGO_PNG}
        alt="Hyper App Store"
        className={imgClassName}
        width={260}
        height={40}
        decoding="async"
      />
    </Link>
  );
}
